<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex lg12 md12 sm12 xl6 xs12>
            <v-card>
              <v-card-title class="pb-5">
                <v-btn
                  :loading="loading"
                  class="submit-btn"
                  @click="addDiscount"
                >
                  <span class="fa fa-bookmark icon-md ml-1"></span>
                  ذخیره
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                    <v-text-field
                      v-model="title"
                      :error-messages="errors.caption"
                      :rules="rules.title"
                      dense
                      label="عنوان"
                      outlined
                      required
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                    <price-input
                      v-model="price_max"
                      :dense="true"
                      :label="'سقف استفاده'"
                    />
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                    <v-text-field
                      v-model="point"
                      :error-messages="errors.point"
                      dense
                      label="امتیاز"
                      outlined
                      type="number"
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                    <v-text-field
                      v-model="discount"
                      :error-messages="errors.discount"
                      dense
                      label="درصد"
                      outlined
                      type="number"
                    />
                  </v-flex>

                  <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                    <v-text-field
                      v-model="usable"
                      :error-messages="errors.expire"
                      :rules="rules.expire"
                      dense
                      label="دفعات قابل استفاده"
                      outlined
                      type="number"
                    />
                  </v-flex>

                  <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                    <v-select
                      v-model="service"
                      :error-messages="errors.service_id"
                      :items="services"
                      :rules="rules.service"
                      dense
                      item-text="title"
                      item-value="id"
                      label="انتخاب پنل"
                      multiple
                      outlined
                    />
                  </v-flex>

                  <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                    <v-select
                      v-model="qrPrice"
                      :error-messages="errors.qrs"
                      :items="qrPrices"
                      dense
                      label="انتخاب تعرفه"
                      multiple
                      outlined
                    />
                  </v-flex>

                  <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                    <v-select
                      v-model="target"
                      :error-messages="errors.own_number"
                      :items="owners"
                      dense
                      item-text="name"
                      item-value="id"
                      label="انتخاب هدف"
                      outlined
                    />
                  </v-flex>

                  <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                    <v-select
                      v-model="show"
                      :error-messages="errors.show"
                      :items="shows"
                      dense
                      item-text="name"
                      item-value="id"
                      label="وضعیت"
                      outlined
                    />
                  </v-flex>

                  <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                    <v-radio-group v-model="row" row>
                      <v-radio label="کد پویا" value="acceptable"></v-radio>
                      <v-radio label="کد ایستا" value="direct"></v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                    <v-text-field
                      v-model="code"
                      :disabled="row === 'acceptable'"
                      :error-messages="errors.code"
                      dense
                      label="کد تخفیف دستی"
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex class="p-2" lg12 md12 sm12 xl12 xs12>
                    <date-picker
                      v-model="expired_at"
                      dense
                      display-format="jYYYY-jMM-jDD HH:mm"
                      format="YYYY-MM-DD HH:mm"
                      label="تاریخ انقضا"
                      outlined
                      type="datetime"
                    >
                    </date-picker>
                  </v-flex>

                  <v-flex class="p-2">
                    <ckeditor
                      v-model="description"
                      :config="editor.editorConfig"
                      :editor="editor.editor"
                    />
                  </v-flex>
                </v-row>

                <!--                <v-row>-->
                <!--                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">-->
                <!--                    <div class="w-100 text-center clickable">-->
                <!--                      <v-img v-ripple @click="pick" id="avatar-block" style="background: gray"-->
                <!--                             :aspect-ratio="1.5" :src="picture || '/media/avatar.webp'"/>-->

                <!--                      <input id="avatar" type="file" class="d-none" name="avatar" @change="picked">-->

                <!--                      <div-->
                <!--                          class="w-100 text-right error&#45;&#45;text pa-3 ml-auto"-->
                <!--                          v-if="errors.picture != null && errors.picture.length > 0"-->
                <!--                          v-text="errors.picture[0]"/>-->
                <!--                    </div>-->
                <!--                  </v-flex>-->
                <!--                </v-row>-->
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { SET_BREADCRUMB } from "../../../../core/services/store/breadcrumbs.module";
import smsTariffPicker from "@/view/pages/pickers/smsTariffPicker";
import priceInput from "@/view/pages/pickers/priceInput";
import subLinePicker from "@/view/pages/pickers/subLinePicker";
import permissionPicker from "@/view/pages/pickers/permissionPicker";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";
import userPicker from "@/view/pages/pickers/userPicker";

export default {
  components: { userPicker, priceInput },
  data() {
    return {
      qrPrices: [],
      qrPrice: undefined,
      loading: false,
      service: [],
      services: [],
      users: [],
      title: "",
      row: "acceptable",
      picture: null,
      code: null,
      target: null,
      price_max: 0,
      expire: null,
      usable: 0,
      permissions: {},
      roleid: null,
      point: null,
      discount: null,
      expired_at: null,
      tariff: {},
      rb: {
        rb: {
          number: null,
          chat: null,
          new: null,
          unique: null,
        },
      },
      subline: {},
      tariffs: [],
      owner: { id: null },
      owners: [
        { id: "all", name: "همه کاربران" },
        { id: "selectable", name: "انتخاب دستی کاربر" },
        { id: "pack", name: "پنل" },
        { id: "product", name: "محصول" },
      ],
      show: { id: null },
      shows: [
        { id: "pending", name: "در حال انتظار" },
        { id: "public", name: "قابل استفاده" },
        { id: "finished", name: "تمام شده" },
      ],
      sortOrder: null,
      features: [],
      description: null,
      roles: [],
      errors: [],
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        },
      },
      rules: {
        title: [
          (val) => (val || "").length > 0 || "فیلد عنوان الزامی می باشد.",
        ],
        services: [(val) => val.length > 0 || "فیلد سرویس الزامی می باشد."],
        price: [(val) => (val || "").length > 0 || "فیلد قیمت الزامی می باشد."],
        expire: [
          (val) => (val || "").length > 0 || "فیلد تاریخ انقضا الزامی می باشد.",
        ],
        // permissions: [val => (val || []).length > 0 || 'فیلد دسترسی الزامی می باشد.'],
        // tariff: [val => !!val || 'فیلد تعرفه الزامی می باشد.'],
      },
    };
  },

  created() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },

  mounted() {
    this.getPacks();
    this.fetchIndexData();
    this.getTariff();
    this.getRoles();
    this.getQrPricing();
  },

  computed: {
    ...mapGetters(["layoutConfig"]),
    ...mapGetters("PermissionsIndex", ["data", "total", "loading"]),

    config() {
      return this.layoutConfig();
    },
  },

  watch: {
    query: {
      handler(query) {
        this.setQuery(query);
        this.fetchIndexData();
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions("PermissionsIndex", [
      "fetchIndexData",
      "setQuery",
      "resetState",
    ]),

    getPacks() {
      this.requestApiGet("pack?length=10000").then(({ data }) => {
        this.services = data.data;
      });
    },

    addDiscount() {
      this.loading = true;
      this.requestApiPost("admin/discount", {
        qrs: this.qrPrice,
        caption: this.title,
        price_max: this.price_max.toString().replace(/,/g, ""),
        expired_at: this.expired_at,
        point: this.point,
        type: this.row,
        code: this.code,
        discount: this.discount,
        users: this.users,
        usable: this.usable,
        target: this.target,
        status: this.show,
        description: this.description,
        pack_id: this.service,
      })
        .then((response) => {
          this.$toast.success("تخفیف جدید با موفقیت ایجاد شد.");
          this.$router.push({ name: "adminDiscounts.index" });
        })
        .catch(({ response }) => {
          this.errors = response;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    pick() {
      document.getElementById("avatar").click();
    },
    setEdited(x) {
      x.edited = true;
    },
    createRegister() {
      this.register.push({
        organName: "",
        type: null,
        date: "",
      });
    },
    picked(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files.length >= 1) {
        this.picture = files[0];
        let avatarBlock = document.getElementById("avatar-block");
        let fileReader = new FileReader();
        fileReader.onload = function (e) {
          let preview = avatarBlock.getElementsByClassName("v-image__image")[0];
          preview.style.backgroundImage = "url('" + this.result + "')";
          preview.style.display = "block";
        };
        fileReader.readAsDataURL(files[0]);
      }
    },
    addCount() {
      this.features.push({
        id: this.features.length + 1,
        key: null,
        value: null,
      });
    },
    decreaseCount() {
      if (this.features.length > 0) {
        this.features.pop();
      }
    },

    getTariff() {
      this.requestApiGet("tariff").then(({ data }) => {
        this.tariffs = data.data;
      });
    },

    getRoles() {
      this.requestApiGet("admin/roles").then((response) => {
        this.roles = response.data.data;
      });
    },
    getQrPricing() {
      this.loading = false;

      axios
        .get(`${this.$qrApi}/user/price/all`)
        .then(({ data }) => {
          this.qrPrices = data.data.map((item) => {
            return {
              ...item,
              value: item.id,
              text: this.qrTypes(item.type) + " " + item.name,
            };
          });
        })
        .catch(({ response }) =>
          console.log("error in get qr pricing: ", response)
        )
        .finally(() => (this.loading = false));
    },
    qrTypes(type) {
      return [
        { value: "instagram", name: "اینستاگرام", icon: "instagram" },
        {
          value: "visitCard",
          name: "کارت ویزیت",
          icon: "card-account-details",
        },
        { value: "Business", name: "کسب و کار", icon: "store" },
        { value: "bShop", name: "صفحه فروشگاهی", icon: "storefront" },
        {
          value: "SocialMedia",
          name: "شبکه های اجتماعی",
          icon: "comment-account",
        },
        { value: "VideoGallery", name: "گالری فیلم", icon: "video" },
        { value: "PhotoGallery", name: "گالری عکس", icon: "image" },
        { value: "singleProduct", name: "معرفی محصول", icon: "package" },
        { value: "menu", name: "منو", icon: "book-open-outline" },
        { value: "text", name: "متن", icon: "text" },
      ].find((item) => item.value === type)?.name;
    },
    //
  },
};
</script>
